<template>
  <div class="sms-jump-ad">
    <div class="number">
      <img src="../../assets/images/1_01.jpg" alt="">
      <div class="number-wrap">
        <div class="count">
          <img class="count-item" v-for="(item,index) in joinedCountArr" :key="index" :src="item">
        </div>
        <div class="hint">众测参与人数</div>
      </div>
    </div>
    <img v-show="!isJoined" src="../../assets/images/1_02.jpg" alt="" @click="check">
    <img v-show="isJoined" src="../../assets/images/2_02_1.png" alt="" @click="toCoupon">
    <img src="../../assets/images/2_03.png" alt="">
    <img src="../../assets/images/2_04.png" alt="">
    <img src="../../assets/images/2_05.png" alt="">
  </div>
</template>

<script>
import axios from 'axios'
import { BASE_URL } from "../../config/config";
import _xt from '../../libs/xiaote.js'
import "weui";
import weui from "weui.js";
import img_0 from '../../assets/images/0.png'
import img_1 from '../../assets/images/1.png'
import img_2 from '../../assets/images/2.png'
import img_3 from '../../assets/images/3.png'
import img_4 from '../../assets/images/4.png'
import img_5 from '../../assets/images/5.png'
import img_6 from '../../assets/images/6.png'
import img_7 from '../../assets/images/7.png'
import img_8 from '../../assets/images/8.png'
import img_9 from '../../assets/images/9.png'
let loading
export default {
  data () {
    return {
      isLiading: true,
      isApp: false,
      isJoined: false,
      userToken: '',
      joinedCountArr: [],
      num: [img_0,img_1,img_2,img_3,img_4,img_5,img_6,img_7,img_8,img_9]
    }
  },
  created() {
    loading = weui.loading('加载中...')
    if (navigator.userAgent.indexOf('Xiaote') != -1) {
      this.getUserToken()
      this.isApp = true
    } else {
      this.init()
      weui.dialog({
        content: '请在小特app打开该页面参与众测',
          buttons: [{
          label: '确定',
          type: 'primary'
        }]
      })
    }
  },
  methods: {
    toCoupon() {
      window.location.href = 'https://shop18976062.youzan.com/wscump/coupon/fetch?alias=qzng70w7'
    },
    init() {
      let data = {
        variables: {
          activityUuid: '57779bb3a0d0441ba2e12411e317f88c',
        },
        query: `query ($activityUuid: String!){
          activity(activityUuid: $activityUuid) {
            joinedCount
            isJoined
          }
        }`
      }
      let config = {headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'X-LC-Id': '4Paj7MSbcOPWbUj4qLbPdm4B-gzGzoHsz',
        'X-LC-Key': 'cTBgegHXVcwPhAl4CTcMcMwm',
        'app-platform': 'web',
        'app-version': '0.0.1',
        'X-LC-Session': this.userToken || ''
      }}
      axios.post(`${BASE_URL}/api/graphql/`, data, config).then(res => {
        console.log(res)
        if (res.data.errors || !res.data.data.activity) {
          loading.hide()
          return
        }
        this.isJoined = res.data.data.activity.isJoined
        let joinedCount = res.data.data.activity.joinedCount
        joinedCount = (joinedCount + '').split('')
        let joinedCountArr = []
        for (let i = 0; i < joinedCount.length; i++) {
          joinedCountArr.push(this.num[joinedCount[i]])
        }
        console.log(joinedCountArr)
        this.joinedCountArr = joinedCountArr
        loading.hide()
      })
    },
    check() {
      if (!this.isApp) {
        weui.dialog({
          content: '请在小特app打开该页面参与众测',
            buttons: [{
            label: '确定',
            type: 'primary'
          }]
        })
        return
      }
      if (!this.userToken) {
        weui.dialog({
          content: '请先登录',
            buttons: [{
            label: '取消',
            type: 'default'
          }, {
            label: '确定',
            type: 'primary',
            onClick: () => this.openLoginView(() => this.check())
          }]
        })
        return
      }
      if (this.isOk) {
        this.join()
        return
      }
      let data = {
        variables: {
          activityUuid: '57779bb3a0d0441ba2e12411e317f88c',
          checkOnly: true
        },
        query: `mutation($activityUuid: String!, $checkOnly: Boolean) {
          joinActivity(activityUuid:$activityUuid, checkOnly: $checkOnly) {
            ruleChecklist {
              isOk
              checklist
            }
            isJoined
            application {
              activityUuid
              user {
                avatarUrl
                nickname
              }
            }
          }
        }`
      }
      let config = {headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'X-LC-Id': '4Paj7MSbcOPWbUj4qLbPdm4B-gzGzoHsz',
        'X-LC-Key': 'cTBgegHXVcwPhAl4CTcMcMwm',
        'app-platform': 'web',
        'app-version': '0.0.1',
        'X-LC-Session': this.userToken
      }}
      loading = weui.loading('报名中...')
      axios.post(`${BASE_URL}/api/graphql/`, data, config).then(res => {
        console.log(res)
        loading.hide()
        let ruleChecklist = res.data.data.joinActivity.ruleChecklist
        let isJoined = res.data.data.joinActivity.isJoined
        if (!ruleChecklist.checklist[2].is_checked) {
          this.isJoined = true
          weui.dialog({
            content: '您已参加过该活动',
              buttons: [{
              label: '确定',
              type: 'primary'
            }]
          })
        } else if (!ruleChecklist.checklist[0].is_checked) {
          weui.dialog({
            content: '请先绑定手机',
              buttons: [{
              label: '取消',
              type: 'default'
            }, {
              label: '确定',
              type: 'primary',
              onClick: () => this.verifyMobilePhone(() => {
                _xt.getUserToken((res) => {
                  if (res) {
                    this.userToken = res
                  }
                  this.check()
                })
              })
            }]
          })
        } else {
          console.log(ruleChecklist)
          if (!ruleChecklist.checklist[1].is_checked) {
            weui.dialog({
              content: '请先绑车',
                buttons: [{
                label: '取消',
                type: 'default'
              }, {
                label: '确定',
                type: 'primary',
                onClick: () => this.bindVehicle(() => this.check())
              }]
            })
          } else {
            this.join()
          }
        }
      })
    },
    join() {
      loading = weui.loading('报名中...')
      let data = {
        variables: {
          activityUuid: '57779bb3a0d0441ba2e12411e317f88c'
        },
        query: `mutation($activityUuid: String!, $checkOnly: Boolean) {
          joinActivity(activityUuid:$activityUuid, checkOnly: $checkOnly) {
            isJoined
          }
        }`
      }
      let config = {headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'X-LC-Id': '4Paj7MSbcOPWbUj4qLbPdm4B-gzGzoHsz',
        'X-LC-Key': 'cTBgegHXVcwPhAl4CTcMcMwm',
        'app-platform': 'web',
        'app-version': '0.0.1',
        'X-LC-Session': this.userToken
      }}
      axios.post(`${BASE_URL}/api/graphql/`, data, config).then(res => {
        console.log(res)
        loading.hide()
        if (res.data.data.joinActivity.isJoined) {
          weui.dialog({
            content: '申请成功',
              buttons: [{
              label: '确定',
              type: 'primary',
              onClick: () => window.location.href = 'https://shop18976062.youzan.com/wscump/coupon/fetch?alias=qzng70w7'
            }]
         })
         this.init()
        }
      })
    },
    getUserToken (cb) {
      _xt.getUserToken((res) => {
        if (res) {
          this.userToken = res
        }
        this.init()
      })
    },
    openLoginView() {
      _xt.openLoginView((res) => {
        if (res) {
          this.userToken = res
        }
      })
    },
    bindVehicle (cb) {
      _xt.bindVehicle((res) => {
        this.setmsg = res
        cb()
      })
    },
    verifyMobilePhone (cb) {
      _xt.verifyMobilePhone((res) => {
        this.verify = res
        cb()
      })
    }
  }
}
</script>

<style scoped>
.sms-jump-ad {
  max-width: 660px;
  font-size: 0;
  margin: auto;
  overflow-x: hidden;
}
.sms-jump-ad img {
  width: 100%;
}
.number {
  position: relative;
}
.number-wrap {
  position: absolute;
  top: 1.4rem;
  width: 100%;
}
.number-wrap .hint {
  text-align: center;
  margin-top: .3rem;
  font-size: .3rem;
  font-weight: 600;
  color: rgba(229, 212, 201, 1);
}
.count {
  display: flex;
  justify-content: center;
  align-items: center;
}
.count img {
  width: auto;
  height: 1.3rem;
}
.count img+img {
  margin-left: .25rem;
}

.loading-div {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background: rgba(0, 0, 0, .8);
  z-index: 999;
  display: flex;
  align-items: center;
}

.load {
  margin: auto;
  width: 80px;
  height: 80px;
  animation: rotate 2s linear infinite;
}
.loading {
  stroke: #e60033;
  stroke-width: 3;
  fill: none;
  animation: dash 1.5s linear infinite;
}
@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 130, 200;
    stroke-dashoffset: -50;
  }
  100% {
    stroke-dasharray: 130, 200;
    stroke-dashoffset: -188;
  }
}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
<style lang="">
  .weui-loading_toast .weui-toast {
    margin: auto;
    width: 2rem;
    height: 2rem;
    min-height: 2rem;
    left: 0;
    right: 0;
  }
  .weui-loading_toast .weui-icon_toast.weui-loading {
    margin: 16px 0 0;
  }
  .weui-loading_toast .weui-toast__content {
    margin-top: -14px;
  }
</style>



// WEBPACK FOOTER //
// App.vue?7facbd8c